export const giftBoxPage = {
  seo: {
    title: "冷凍宅配與禮盒｜來加綉綉紅豆餅",
    description:
      "來加綉綉紅豆餅提供冷凍宅配、節慶禮盒、企業下午茶與團購訂購服務，讓顧客在家中、辦公室與聚會場合也能享受手作紅豆餅的香氣。",
  },
  hero: {
    tag: "冷凍宅配 & 禮盒",
    title: "把剛出爐的期待，帶回家慢慢享用",
    subtitle:
      "來加綉綉規劃冷凍宅配與禮盒服務，讓紅豆餅不只在現場好吃，也能成為家庭分享、公司下午茶、節慶送禮與團購預訂的溫暖選擇。",
    ctaPrimary: "我要詢問宅配",
    ctaSecondary: "我要訂購禮盒",
  },
  situations: {
    sectionTitle: "適合這些時候，送上一盒來加綉綉",
    items: [
      {
        title: "家庭點心",
        desc: "放在冷凍庫，需要時回烤，就是一家人的下午茶。",
        icon: "ri-home-heart-line",
      },
      {
        title: "公司下午茶",
        desc: "適合辦公室團購、會議點心與員工福利。",
        icon: "ri-building-2-line",
      },
      {
        title: "節慶送禮",
        desc: "中秋、春節、開幕、活動贈禮，都能用紅豆餅傳達溫度。",
        icon: "ri-gift-2-line",
      },
      {
        title: "市集與活動訂購",
        desc: "適合活動餐點、品牌快閃、社區聚會與團體預訂。",
        icon: "ri-store-2-line",
      },
    ],
  },
  plans: {
    sectionTitle: "冷凍宅配與禮盒方案",
    plans: [
      {
        name: "人氣綜合盒",
        desc: "經典紅豆、奶油卡士達、芋泥香香等人氣口味組合。",
        audience: "第一次購買、家庭分享、團購試吃",
        cta: "詢問綜合盒",
      },
      {
        name: "經典紅豆盒",
        desc: "主打經典紅豆口味，適合喜歡傳統風味的顧客。",
        audience: "長輩、節慶送禮、固定回購",
        cta: "詢問經典盒",
      },
      {
        name: "企業 / 團購客製",
        desc: "可依數量、口味、包裝與配送需求討論。",
        audience: "公司下午茶、活動點心、團體訂購",
        cta: "洽詢團購方案",
      },
    ],
    disclaimer:
      "實際口味、價格、保存方式與配送範圍，請以官方公告與客服回覆為準。",
  },
  reheat: {
    sectionTitle: "在家也能吃出接近現烤的香氣",
    steps: [
      {
        step: "STEP 01",
        title: "冷凍保存",
        desc: "收到後請依包裝標示冷凍保存。",
      },
      {
        step: "STEP 02",
        title: "取出回烤",
        desc: "依建議時間使用烤箱、氣炸鍋或平底鍋回烤。",
      },
      {
        step: "STEP 03",
        title: "趁熱享用",
        desc: "外皮恢復香氣後趁熱享用，口感更佳。",
      },
    ],
    note: "實際回烤時間會依設備不同微調。",
  },
  orderFlow: {
    sectionTitle: "訂購流程",
    steps: [
      "加入 LINE 或填寫表單",
      "告知需求：數量、口味、配送地區、希望到貨時間",
      "客服確認品項、金額與配送方式",
      "完成付款",
      "安排製作與出貨",
      "收到後依說明保存與回烤",
    ],
  },
  bottomCta: {
    title: "想先詢問口味與配送？",
    ctaPrimary: "加入 LINE 詢問宅配",
    ctaSecondary: "填寫團購表單",
  },
};